import { createContext } from 'react';

import { identity } from 'ramda';

import { TCalendarDay, CalendarEvent } from '../../types';

export enum DragTypeEnum {
  move = 'move',
  extend = 'extend',
}

export type ValueT = {
  onDrop: (item: Pick<CalendarEvent, 'id'>, calendarDay: Pick<TCalendarDay, 'dayNumber'>, type?: DragTypeEnum) => void;
  onMultiDrop: (updatedEvents: CalendarEvent[]) => void;
  onHover: (item: Pick<CalendarEvent, 'id'>, calendarDay: Pick<TCalendarDay, 'dayNumber'>, type?: DragTypeEnum) => void;
  setTempCalendarEvents: (events: CalendarEvent[]) => void;
  setDraggingStartDay: (dayNumber: number) => void;
  updateSelectedEvents: (events: CalendarEvent[]) => void;
  selectedEvents: CalendarEvent[];
  tempCalendarEvents: CalendarEvent[];
};

export const context = createContext<ValueT>({
  onDrop: identity,
  onMultiDrop: identity,
  onHover: identity,
  setTempCalendarEvents: identity,
  setDraggingStartDay: identity,
  updateSelectedEvents: identity,
  selectedEvents: [],
  tempCalendarEvents: [],
});

export const Provider = context.Provider;
